// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCompareBarsIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M10 17v4H2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2m4-8h-4c-1.1 0-2 .9-2 2v2h2c1.1 0 2 .9 2 2v6h4V11c0-1.1-.9-2-2-2m6-6h-4c-1.1 0-2 .9-2 2v2h2c1.1 0 2 .9 2 2v12h4V5c0-1.1-.9-2-2-2" />
  </g>
);
export default SvgCompareBarsIcon;
SvgCompareBarsIcon.displayName = 'SvgCompareBarsIcon';
